import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CaiInfoModal } from "../../components/cai-info-modal/CaiInfoModal";
import AuthConfirmCancelProcedureModal from "../../components/cancel-authorize-confirm-claim-modal/AuthConfirmCancelProcedureModal";
import FilesUploadListCmp from "../../components/file/FilesUploadListCmp";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import LoaderCmp from "../../components/loader/LoaderCmp";
import { RealtimeModal } from "../../components/modal/RealtimeModal";
import { LNextButton, NextButton, SecondChoiseButton } from "../../components/styled/Button.style";
import { LTitleIconSection, Section } from "../../components/styled/Containers.style";
import { LIconContainer } from "../../components/styled/Icon.style";
import { Vspace } from '../../components/styled/Separators.style';
import { LPageTitle, LSimpleText, LSmallPageTitle, PageTitle, TextDefault } from "../../components/styled/Text.style";
import { AUTH_CONFIRM_BASE_ROUTH, AUTH_CONFIRM_PATHS } from "../../routes/AuthConfirmRouter";
import { LINEAR_BASE_ROUTE } from "../../routes/linearRouteConstants";
import { selectCommunicationData } from "../../store";
import { invokeSignatureAct, saveCommunicationAct } from "../../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { CommunicationType, EventCommType, EventValueEnum, FileItemType } from "../../types/communication/communicationDataType";
import { checkDimensionsFileAdded, composeUrl } from "../../utils/utils";
import PageContainerCmp from "../PageContainerCmp";

const AuthConfirmUploadDocPage = () => {
    const dispatch = useAppDispatch();
    const communicationData = useAppSelector(selectCommunicationData)
    const { invokeSignatureMetadata, communication } = communicationData
    let navigate = useNavigate();
    let { token } = useParams();

    const [openCaiModal, setOpenCaiModal] = useState(false)
    const [cancelModalOpened, setCancelModalOpened] = useState<boolean>(false)
    const [authConfirmDocsList, setAuthConfirmDocsList] = useState<FileItemType[]>(communication.authConfirmDocsList)
    const isLinear = communication?.companyName === "LINEAR";

    const shouldDisableButton = () => {
        if (isLinear === true) return authConfirmDocsList?.length <= 1;
        return !(authConfirmDocsList?.length);
    }

    const goToNextStepHandler = () => {
        /* istanbul ignore next */
        const baseRoute = isLinear === true ? `${LINEAR_BASE_ROUTE}/${AUTH_CONFIRM_BASE_ROUTH}` : AUTH_CONFIRM_BASE_ROUTH
        const nextPath = composeUrl(token, AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_END_PROCESS_SUCCESS, baseRoute)
        const newEvent = new EventCommType({ value: EventValueEnum.AUTH_CONFIRM_STEPS_COMPLETED })
        /* istanbul ignore next */
        const data = new CommunicationType({
            ...communication,
            authConfirmDocsList
        })
        /* istanbul ignore next */
        dispatch(saveCommunicationAct({
            data,
            events: [newEvent]
        }))
        /* istanbul ignore next */
        dispatch(invokeSignatureAct({
            data: null,
            callback: () => navigate(nextPath)
        }))
    }

    const goToPreviousStepHandler = () => {
        const baseRoute = communication?.companyName === "LINEAR" ? `${LINEAR_BASE_ROUTE}/${AUTH_CONFIRM_BASE_ROUTH}` : `${AUTH_CONFIRM_BASE_ROUTH}`;
        const nextPath = composeUrl(token, AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CAI_PREVIEW, baseRoute)
        navigate(nextPath)
    }

    return (
        <>

            <AuthConfirmCancelProcedureModal
                modalOpened={cancelModalOpened}
                onCloseHandler={() => setCancelModalOpened(false)} />

            <RealtimeModal
                modalOpened={openCaiModal}
                hTitle="Constatazione amichevole"
                hCloseButton={true}
                onCloseHandler={() => setOpenCaiModal(false)}>
                <CaiInfoModal />
            </RealtimeModal>

            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_UPLOAD_DOC}
                removeNextBtn
            >

                {invokeSignatureMetadata?.isLoading && <LoaderCmp className="cover cai-preview" />}
                <Section linear={isLinear}>
                    {isLinear === false && <>
                        <PageTitle>Documento di riconoscimento</PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered sm>Infine ti chiediamo di caricare una foto di un tuo documento di riconoscimento in corso di validità, <strong>preferibilmente la patente</strong>.</TextDefault>
                    </>}
                    {isLinear === true && <LTitleIconSection style={{ marginLeft: "10px" }}>
                        <LIconContainer><FontAwesomeIcon fontSize={24} icon={faChevronLeft} onClick={goToPreviousStepHandler} /></LIconContainer>
                        <LPageTitle style={{ marginLeft: "20px" }}>CARICA DOCUMENTO</LPageTitle></LTitleIconSection>}
                    {isLinear === true && <>
                        <Vspace qty={2}></Vspace>
                        <LSimpleText>Infine ti chiediamo di caricare una foto di un tuo documento di riconoscimento in corso di validità, <strong>preferibilmente la patente</strong>.</LSimpleText>
                        <Vspace qty={2}></Vspace>
                    </>}
                </Section>

                {isLinear === false && <Section>
                    <FilesUploadListCmp
                        companyName={communication?.companyName}
                        files={authConfirmDocsList}
                        setFiles={setAuthConfirmDocsList}
                        fileType={"AUTH-CONFIRM-DOCS"}
                        arrayDbPropSync={"authConfirmDocsList"}
                        textLabel={"Carica documento"}
                    />
                </Section>}
                {isLinear === true && <>
                    <LSmallPageTitle style={{ flex: 0 }}>DOCUMENTO DI RICONOSCIMENTO</LSmallPageTitle>
                    <LSimpleText style={{ width: "100%" }}>Max 2 file:</LSimpleText>
                    <Vspace qty={2}></Vspace>
                    <FilesUploadListCmp
                        files={authConfirmDocsList}
                        setFiles={setAuthConfirmDocsList}
                        fileType={"CONFIRM-IDENTITY"}
                        arrayDbPropSync={"authConfirmDocsList"}
                        companyName={communication?.companyName}
                        maxLimit={2}
                        onPreUploadCallback={checkDimensionsFileAdded}
                    />
                </>}

                <Vspace qty={4}></Vspace>

                {isLinear === false && <Section>
                    <Vspace></Vspace>
                    <NextButton
                        disabled={shouldDisableButton()}
                        onClick={goToNextStepHandler}>Procedi</NextButton>
                    <Vspace></Vspace>
                    <SecondChoiseButton onClick={() => setCancelModalOpened(true)}>Non posso caricare il documento</SecondChoiseButton>
                </Section>}

                {isLinear === true && <Section linear={true}>
                    <Vspace></Vspace>
                    <LNextButton
                        disabled={shouldDisableButton()}
                        onClick={goToNextStepHandler}>Procedi</LNextButton>
                    <TextDefault style={{ 'display': 'none' }}></TextDefault>
                    <Vspace qty={2}></Vspace>
                    <SecondChoiseButton linear={true} onClick={goToPreviousStepHandler}>Torna indietro</SecondChoiseButton>
                </Section>}

                {isLinear === true && <LinearFooterCmp />}

            </PageContainerCmp>
        </>

    )
}

export default AuthConfirmUploadDocPage